import { motion } from 'framer-motion'
import PageHeader from '@shared/components/PageHeader'
import SEO from '@shared/components/SEO'

const PARTICULARS: [string, string][] = [
    ['Journal Title', 'Indian Studies Review'],
    ['P-ISSN (Print)', '2583-004X'],
    ['E-ISSN (Online)', '2582-7154'],
    ['RNI Reg. No.', 'DELENG/2020/76938'],
    ['Frequency (Print)', 'Bi-Annually'],
    ['Frequency (Online)', 'Bi-Annually'],
    ['Publisher', 'Centre for Study of Politics and Governance'],
    ['Place of Publication', 'New Delhi, India'],
    ['Chief Editor', 'Prof. Sangit Kumar Ragi'],
    ['Starting Year (Print)', '2020'],
    ['Starting Year (Online)', '2020'],
    ['Subject', 'Social Sciences (Multi-Disciplinary)'],
    ['Language', 'English'],
    ['Publication Format', 'Print & Online']
]

export default function JournalParticulars() {
    return (
        <>
            <SEO
                title="Journal Particulars"
                description="Bibliographic and registration particulars of Indian Studies Review — ISSN, RNI, frequency, publisher and editorial details."
                path="/journal-particulars"
            />
            <PageHeader
                eyebrow="The Journal"
                title="Journal Particulars"
                lede="Bibliographic, registration and publication particulars of Indian Studies Review."
            />

            <section className="section">
                <div className="container-prose" style={{ maxWidth: '46rem' }}>
                    <motion.dl
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        style={{ border: '1px solid var(--color-rule)', background: 'var(--color-paper-50)' }}
                    >
                        {PARTICULARS.map(([label, value], i) => (
                            <div
                                key={label}
                                className="grid grid-cols-1 sm:grid-cols-5 items-baseline gap-1 px-5 sm:px-7 py-4"
                                style={{
                                    borderTop: i === 0 ? 'none' : '1px solid var(--color-rule)',
                                    background: i % 2 === 1 ? 'rgba(184,168,114,0.05)' : 'transparent'
                                }}
                            >
                                <dt
                                    className="sm:col-span-2 text-[11px] uppercase font-semibold"
                                    style={{ letterSpacing: '0.14em', color: 'var(--color-gold-700)' }}
                                >
                                    {label}
                                </dt>
                                <dd
                                    className="sm:col-span-3 text-[15px] font-medium"
                                    style={{ color: 'var(--color-ink-700)' }}
                                >
                                    {value}
                                </dd>
                            </div>
                        ))}
                    </motion.dl>
                </div>
            </section>
        </>
    )
}
